import Vue        from "vue";
import Router     from "vue-router";
import Head       from "vue-head";
import Home       from "@/views/Home";
import CheckLogin from "@/views/CheckLogin";
import {isNil}    from "lodash";
import store      from "@/store";

Vue.use(Router);

/* If you don't know about VueHead, please refer to https://github.com/ktquez/vue-head */
Vue.use(
    Head,
    {
        complement: process.env.VUE_APP_TITLE
    }
);

/* If you don't know about VueRouter, please refer to https://router.vuejs.org/ */
const router = new Router(
    {
        mode  : "history",
        base  : process.env.BASE_URL,
        routes: [
            {
                path     : "/home",
                name     : "home",
                component: Home,
                meta     : {
                    authNotRequired: true,
                    layout         : "public"
                }
            },
            {
                path     : "/check-login",
                name     : "check-login",
                component: CheckLogin,
                meta     : {
                    authNotRequired: true,
                    layout         : "public"
                }
            },
            {
                path     : "/login",
                name     : "login",
                component: () => import(/* webpackChunkName: "client-chunk-login" */ "@/views/Login.vue"),
                meta     : {
                    authNotRequired: true,
                    layout         : "public"
                }
            },
            {
                path     : "/",
                name     : "dashboard",
                component: () => import(/* webpackChunkName: "client-chunk-dashboard" */ "@/views/Dashboard.vue")
            },
            {
                path     : "/demands/:id/chat",
                name     : "demands_chat",
                component: () => import(/* webpackChunkName: "client-chunk-chat" */ "@/views/Chat.vue")
            },
            {
                path     : "/demands/new",
                name     : "demands_new",
                component: () => import(/* webpackChunkName: "client-chunk-demand" */ "@/views/Demand.vue")
            },
            {
                path     : "/demands/:id",
                name     : "demands_edit",
                component: () => import(/* webpackChunkName: "client-chunk-demand" */ "@/views/Demand.vue")
            },
            {
                path     : "/demands",
                name     : "demands",
                component: () => import(/* webpackChunkName: "client-chunk-demands" */ "@/views/Demands.vue")
            },
            {
                path     : "/profile/:id",
                name     : "profile",
                component: () => import(/* webpackChunkName: "client-chunk-profile" */ "@/views/Profile.vue")
            },
            {
                path     : "/users",
                name     : "users",
                component: () => import(/* webpackChunkName: "client-chunk-users" */ "@/views/Users.vue")
            },
            {
                path    : "*",
                redirect: "/home"
            }
        ]
    }
);

/**
 * Handle user redirections
 */
// eslint-disable-next-line consistent-return
router.beforeEach(
    (to, from, next) => {
        if (!(to.meta && to.meta.authNotRequired) && isNil(store.state.authentication.user)) {
            const path = store.state.authentication.user === null ? "/login" : "/check-login";
            return next(`${path}?redirectUrl=${to.path}`);
        }

        return next();
    }
);

export default router;
